<template>
<div>
  <el-card shadow="hover">
    <label class="head-tit">费用设置-{{supplierName}}</label>
  </el-card>
  <!-- 列表数据 -->
  <el-card shadow="hover">
    <el-button type="primary" @click="add">新增</el-button>
    <el-table
      :data="suppliersetList"
      style="margin: 20px 0"
      >
      <el-table-column
        type="index"
        label="序号"
        align="center"
        width="80">
      </el-table-column>
      <el-table-column
        prop="costProjectName"
        label="收费项目"
        align="center"
        width="230">
      </el-table-column>
      <el-table-column
        prop="costTypeName"
        label="费用类型"
        align="center"
        width="140">
      </el-table-column>
      <el-table-column
        prop="computeTypeName"
        label="计算方式"
        align="center"
        width="200">
        <template slot-scope="scope">
          {{ scope.row.computeTypeName ? scope.row.computeTypeName : '-' }}
        </template>
      </el-table-column>
      <el-table-column
        prop="price"
        align="center"
        label="单价(元)"
        width="180" >
      <template slot-scope="scope">
        <label v-if="scope.row.computeType === 'RECKON_TYPE_CUBIC_TONS' || scope.row.price === null">-</label>
        <label v-else>{{parseFloat(scope.row.price).toFixed(2)}}</label>
      </template>
      </el-table-column>
      <el-table-column
        align="center"
        width="110"
        label="操作">
        <template slot-scope="scope">
          <div class="operation-warp">
            <label style="cursor: pointer;" @click="edit(scope.row)">编辑</label>
            <label style="cursor: pointer;" @click="delet(scope.row)">删除</label>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <label style="color: #808080;padding-bottom: 10px;display: block;">备注：费用不填时，默认按仓库费用配置计费</label>
  </el-card>
  <!-- 弹窗 -->
  <el-dialog
    :title="dialogForm.title"
    :visible.sync="dialogForm.visible"
    width="45%"
    :before-close="handleClose">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
      <el-form-item v-if="dialogForm.title === '新增收费项目'" label="收费项目" prop="costProject">
        <el-select v-model="ruleForm.costProject" placeholder="请选择" @change="costChange" no-data-text="无可新增项">
          <el-option
            v-for="item in select"
            :key="item.code"
            :label="item.name"
            :value="item.code">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="dialogForm.title === '编辑收费项目'" label="收费项目" prop="costProject">
        <el-select :disabled="true" v-model="ruleForm.costProject" placeholder="请选择" @change="costChange">
          <el-option
            v-for="item in projectSelect"
            :key="item.code"
            :label="item.name"
            :value="item.code">
          </el-option>
        </el-select>
      </el-form-item>
      <!-- 配送费、退货费 tabs切换 -->
      <p class="tips" v-if="ruleForm.costProject && isDeliveryCancel && storehouseList.length === 0">请先配置“配送仓点”！</p>
      <template v-if="ruleForm.costProject && isDeliveryCancel">
        <el-tabs v-model="activeName" v-if="ruleForm.dispatchConfigList.length > 0 && this.storehouseList.length > 0">
          <el-tab-pane :label="item.ydppName" :name="index.toString()" v-for="(item,index) in storehouseList" :key="index">
            <el-form-item label="计费方式" prop="dispatchConfigList">
              <el-select v-if="ruleForm.dispatchConfigList[index]" v-model="ruleForm.dispatchConfigList[index].computeType" no-data-text="请先选择收费任务类型" placeholder="请选择" @change="computeChange(ruleForm.dispatchConfigList[index])">
                <el-option
                  v-for="item in arr"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>

            <!-- 收费类型---配送费、多货退货、售后退货 -->
            <div v-if="ruleForm.dispatchConfigList[index] && ruleForm.dispatchConfigList[index].computeType === 'RECKON_TYPE_CUBIC_TONS'">
              <el-form-item label="计费维度" prop="dispatchConfigList">
                <el-select v-model="ruleForm.dispatchConfigList[index].dimension" placeholder="请选择" @change="dimensionChange(ruleForm)">
                  <el-option
                    v-for="item in dimensionSelect"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
              <label class="desc">每次指每个任务完成时生成费用明细,固定周期指每个周期内只生成一条费用明细，到期自动延续</label>
              <el-form-item v-if="ruleForm.dispatchConfigList[index].dimension === 'COST_DIMENSION_FIXED_PERIOD'" label="开始日期" prop="dispatchConfigList">
                <el-date-picker
                  v-model="ruleForm.dispatchConfigList[index].date"
                  type="date"
                  :picker-options="pickerOptions"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
              <label style="color: #cf0000" v-if="ruleForm.dispatchConfigList[index].dimension === 'COST_DIMENSION_FIXED_PERIOD'" class="desc">建议在开始时间前5分钟修改，修改后至开始时间的时间段内不产生费用</label>
              <el-form-item v-if="ruleForm.dispatchConfigList[index].dimension === 'COST_DIMENSION_FIXED_PERIOD'" label="开始时间" prop="dispatchConfigList">
                <el-time-select
                  v-model="ruleForm.dispatchConfigList[index].time"
                  :picker-options="{
                    start: '00:00',
                    step: '00:60',
                    end: '23:00'}"
                  placeholder="选择时间">
                </el-time-select>
              </el-form-item>
              <el-form-item v-if="ruleForm.dispatchConfigList[index].dimension === 'COST_DIMENSION_FIXED_PERIOD'" label="时长" :prop="'dispatchConfigList.'+index+'.duration'" :rules="rules.duration">
                <el-input class="input-with-select" v-model="ruleForm.dispatchConfigList[index].duration" placeholder="请输入时长" @blur="Num(ruleForm)">
                  <template slot="append">
                    <el-form-item prop="dispatchConfigList">
                      <el-select v-model="ruleForm.dispatchConfigList[index].durationType" placeholder="请选择">
                        <el-option
                          v-for="item in durationSelect"
                          :key="item.code"
                          :label="item.name"
                          :value="item.code">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </template>
                </el-input>
              </el-form-item>
            </div>
            <el-form-item label="计费单位" prop="dispatchConfigList">
              <el-input disabled :value="costUnit[0]"></el-input>
            </el-form-item>
            <el-form-item label="单价" prop="dispatchConfigList" v-if="ruleForm.dispatchConfigList[index] && ruleForm.dispatchConfigList[index].computeType !== 'RECKON_TYPE_CUBIC_TONS'">
              <el-input :maxlength="10" placeholder="请输入单价" v-model="ruleForm.dispatchConfigList[index].price" @blur="Num(ruleForm)">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
            <!-- 不足一箱 -->
            <el-form-item label="不足一箱" prop="dispatchConfigList" v-if="isShowBox[index]">
              <el-radio v-model="ruleForm.smallestUnit" :label="0">按件</el-radio>
              <el-radio v-model="ruleForm.smallestUnit" :label="1">按箱(不足一箱算一箱)</el-radio>
            </el-form-item>

            <!-- 配送费、退货费---重量/体积 -->
            <div v-if="ruleForm.dispatchConfigList[index] && ruleForm.dispatchConfigList[index].computeType === 'RECKON_TYPE_CUBIC_TONS'">
              <el-form-item label="首重" :prop="'dispatchConfigList.'+index+'.beginVal'" :rules="rules.beginVal">
                <el-input :maxlength="10" placeholder="请输入首重" v-model="ruleForm.dispatchConfigList[index].beginVal" @blur="Num(ruleForm)">
                  <template slot="append">吨</template>
                </el-input>
              </el-form-item>
              <el-form-item label="起步价" :prop="'dispatchConfigList.'+index+'.startPrice'" :rules="rules.beginVal">
                <el-input :maxlength="10" placeholder="请输入起步价" v-model="ruleForm.dispatchConfigList[index].startPrice" @blur="Num(ruleForm)">
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
              <el-form-item label="续重单价" :prop="'dispatchConfigList.'+index+'.price'" :rules="rules.beginVal">
                <el-input :maxlength="10" placeholder="请输入续重单价" v-model="ruleForm.dispatchConfigList[index].price" @blur="Num(ruleForm)">
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
              <el-form-item label="计费单位" prop="dispatchConfigList">
                <el-input :disabled="true" :value="costUnit[1]"></el-input>
              </el-form-item>
              <el-form-item label="首方" :prop="'dispatchConfigList.'+index+'.volumeBeginVal'" :rules="rules.beginVal">
                <el-input :maxlength="10" placeholder="请输入首方" v-model="ruleForm.dispatchConfigList[index].volumeBeginVal" @blur="Num(ruleForm)">
                  <template slot="append">立方</template>
                </el-input>
              </el-form-item>
              <el-form-item label="起步价" :prop="'dispatchConfigList.'+index+'.volumeStartPrice'" :rules="rules.beginVal">
                <el-input :maxlength="10" placeholder="请输入起步价" v-model="ruleForm.dispatchConfigList[index].volumeStartPrice" @blur="Num(ruleForm)">
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
              <el-form-item label="续重单价" :prop="'dispatchConfigList.'+index+'.volumePrice'" :rules="rules.beginVal">
                <el-input :maxlength="10" placeholder="请输入续重单价" v-model="ruleForm.dispatchConfigList[index].volumePrice" @blur="Num(ruleForm)">
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
            </div>
          </el-tab-pane>
        </el-tabs><br>
        <!-- 计算规则 -->
        <calculation-rules v-if="isShowComputeRule[activeName]" :ruleForm='ruleForm' :type="costUnit[0]" :showTips="true" :isDeliveryCancel="isDeliveryCancel"></calculation-rules>
      </template>
      <!-- 仓储费、装卸费、贴标费、包膜费 -->
      <template v-else>
        <el-form-item label="计费方式" prop="computeType">
          <el-select v-model="ruleForm.computeType" no-data-text="请先选择收费任务类型" placeholder="请选择" @change="computeChange(ruleForm)">
            <el-option
              v-for="item in arr"
              :key="item.code"
              :label="item.name"
              :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <div v-if="ruleForm.computeType">
          <el-form-item label="计费单位" prop="costUnit">
            <el-input :disabled="true" :value="costUnit[0]"></el-input>
          </el-form-item>
          <!-- 计费方式---非重量类型 -->
          <el-form-item v-if="ruleForm.computeType !== 'RECKON_TYPE_CUBIC_TONS'" label="单价" prop="price">
            <el-input :maxlength="10" placeholder="请输入单价" v-model="ruleForm.price" @blur="Num(ruleForm)">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <!-- 不足一箱 -->
          <el-form-item label="不足一箱" prop="smallestUnit" v-if="isShowBox[0]">
            <el-radio v-for="(item,index) in boxSelect" :key="index" v-model="ruleForm.smallestUnit" :label="item.value">{{ item.label }}</el-radio>
          </el-form-item>
          <!-- 仓储费-普通-板/天 -->
          <template v-if="ruleForm.computeType == 'RECKON_TYPE_PLATE_DAY'">
            <el-form-item label="余数计算" prop="remainder">
              <el-select v-model="ruleForm.remainder">
                <el-option
                  v-for="item in remainderSelect"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="ruleForm.remainder == '1'" label="比值" prop="remainderRatio">
              <el-input v-model="ruleForm.remainderRatio">
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </template>
          <!-- 装卸费---重量/体积 -->
          <div v-if="ruleForm.costProject === 'COST_PRO_MOVE' && ruleForm.computeType === 'RECKON_TYPE_CUBIC_TONS'">
            <el-form-item label="每吨单价" prop="price" v-if="ruleForm.costProject === 'COST_PRO_MOVE'">
              <el-input :maxlength="10" placeholder="请输入每吨单价" v-model="ruleForm.price" @blur="Num(ruleForm)">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
            <el-form-item label="计费单位" prop="costUnit2">
              <el-input :disabled="true" :value="costUnit[1]"></el-input>
            </el-form-item>
            <el-form-item label="每立方单价" prop="volumePrice">
              <el-input :maxlength="10" placeholder="请输入每立方单价" v-model="ruleForm.volumePrice" @blur="Num(ruleForm)">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </div>
          <!-- 仓储费-立方/天、装卸费-重量体积、配送费-重量体积、退货费-重量体积 -->
          <!-- 计算规则 -->
          <calculation-rules v-if="isShowComputeRule[0]" :ruleForm='ruleForm' :type="costUnit[0]"></calculation-rules>
        </div>
      </template>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submit('ruleForm')">确 定</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
import { formatDate } from '@/utils/formatDate'
import calculationRules from '../costConfigure/components/calculationRules'
import costConfigure from '@/store/costConfigure/index'
import supplierManage from '@/store/supplierManage/index'
import {GETSUPPLIERCOST, SUPPLIERADDCOST, GETCOSTBYID, SUPPLIERUPDATECOST, SUPPLIERDELETE} from '@/store/supplierManage/types'
import {GETCHILDS, YCDISPATCHPLATFORMPOINT} from '@/store/costConfigure/types'
export default {
  name: 'SupplierSet',
  components: {
    calculationRules
  },
  data () {
    return {
      activeName: '0', // tabs索引
      // today: formatDate(new Date() + 1, 'yyyy-MM-dd'), // 当前日期
      defaultTime: formatDate(new Date(), 'hh') === '23' ? '00:00' : (Number(formatDate(new Date(), 'hh')) + 1).toString() + ':00', // 当前时分
      arr: [], // 计算方式下拉框
      remainderSelect: [
        {label: '超过但不足一板算一板', value: 0},
        {label: '超过比值算一板', value: 1}
      ], // 余数计算下拉框
      supplierCode: '', // 供应商编码
      supplierName: '',
      warehouseCode: '',
      select: [], // 新增/编辑收费项目下拉框
      // 表单数据
      ruleForm: {
        costProject: '', // 收费项目 数据字典
        dimension: '', // 计费维度 数据字典
        computeType: '', // 计算方式 数据字典
        time: '', // 开始时间
        date: '', // 开始日期
        // startTime: '', // 开始时间
        duration: '', // 时长
        durationType: '', // 时长类型
        price: '', // 单价
        startPrice: '', // 起步价
        beginVal: '', // 首重
        volumePrice: '', // 体积的单价
        volumeStartPrice: '', // 体积的起步价
        volumeBeginVal: '', // 体积的首重
        dispatchConfigList: [], // 配送仓点
        smallestUnit: 0, // 不足一箱
        smallestRule: { a: 4, b: 4, c: 4 }, // 体积计算规则
        isAcc: 0, // 零数累加规则
        startPriceConfig: 0
      },
      // 表单校验
      rules: {
        costProject: [
          { required: true, message: '请选择收费项目', trigger: ['blur'] },
          { required: false, message: '请选择收费项目', trigger: ['change'] }
        ],
        computeType: [
          { required: true, message: '请选择计费方式', trigger: ['blur'] },
          { required: false, message: '请选择计费方式', trigger: ['change'] }
        ],
        // startTime: [
        //   { required: true, message: '请选择开始时间', trigger: ['blur'] },
        //   { required: false, message: '请选择开始时间', trigger: ['change'] }
        // ],
        date: [
          { required: true, message: '请选择开始日期', trigger: ['blur'] },
          { required: false, message: '请选择开始日期', trigger: ['change'] }
        ],
        time: [
          { required: true, message: '请选择开始时间', trigger: ['blur'] },
          { required: false, message: '请选择开始时间', trigger: ['change'] }
        ],
        duration: [
          { required: true, trigger: 'blur', validator: this.validateTime }
        ],
        durationType: [
          { required: true, message: '请选择时长类型', trigger: ['blur'] },
          { required: false, message: '请选择时长类型', trigger: ['change'] }
        ],
        dimension: [
          { required: true, message: '请选择计费维度', trigger: ['blur'] },
          { required: false, message: '请选择计费维度', trigger: ['change'] }
        ],
        price: [
          { required: true, trigger: 'blur', validator: this.validateNum }
        ],
        smallestUnit: [
          { required: true, message: '请选择不足一箱', trigger: ['blur', 'change'] }
        ],
        volumePrice: [
          { required: true, trigger: 'blur', validator: this.validateVolume }
        ],
        beginVal: [
          { required: true, validator: this.validateVal, trigger: 'blur' }
        ],
        remainder: [
          { required: true, message: '请选择余数计算', trigger: ['blur'] }
        ],
        remainderRatio: [
          { required: true, validator: this.validateNumber, trigger: 'blur' }
        ]
      },
      // 任务类型下拉框
      childeList: [{
        name: '每次',
        code: 'everyTime'
      }, {
        name: '固定周期',
        code: 'fixedTime'
      }],
      // dialog配置
      dialogForm: {
        title: '新增收费项目',
        visible: false
      },
      // 时间选择配置
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 24 * 3600 * 1000// 如果不包括今天。就是return time.getTime() > Date.now() - 24*3600*1000;
        }
        // selectableRange: this.defaultTime + '-' + '24:00:00'
      },
      storehouseArr: [], // 配送仓点列表
      boxSelect: [{label: '按件', value: 0}, {label: '按箱(不足一箱算一箱)', value: 1}] // 不足一箱下拉框
    }
  },
  computed: {
    // 供应商费用配置列表
    suppliersetList () {
      return supplierManage.state.suppliersetList
    },
    // 收费项目下拉框
    projectSelect () {
      return costConfigure.state.projectSelect
    },
    // 计算维度下拉框
    dimensionSelect () {
      return costConfigure.state.dimensionSelect
    },
    // 时长类型下拉框
    durationSelect () {
      return costConfigure.state.durationSelect
    },
    // 计费方式下拉框
    chargingSelect () {
      return costConfigure.state.chargingSelect
    },
    // 配送仓点列表
    storehouseList () {
      return costConfigure.state.storehouseList
    },
    // 计费单位数据
    costUnit () {
      let costUnit = ''
      let costUnit2 = ''
      let type = ''
      if (this.isDeliveryCancel) {
        type = this.ruleForm.dispatchConfigList[parseInt(this.activeName)].computeType
      } else {
        type = this.ruleForm.computeType
      }
      if (type === 'RECKON_TYPE_M2_DAY') {
        costUnit = '平方/天'
      } else if (type === 'RECKON_TYPE_BOX_DAY') {
        costUnit = '箱/天'
      } else if (type === 'RECKON_TYPE_PLATE_DAY') {
        costUnit = '板/天'
      } else if (type === 'RECKON_TYPE_CUBIC_DAY') {
        costUnit = '立方/天'
      } else if (type === 'RECKON_TYPE_BOX') {
        costUnit = '箱'
      } else if (type === 'RECKON_TYPE_CUBIC_TONS') {
        costUnit = '吨'
        costUnit2 = '立方'
      } else if (type === 'RECKON_TYPE_A_TIME') {
        costUnit = '趟'
      } else if (type === 'RECKON_TYPE_PLATE') {
        costUnit = '板'
      } else if (type === 'RECKON_TYPE_A') {
        costUnit = '个'
      }
      return [costUnit, costUnit2]
    },
    // 标识
    costMask () {
      return supplierManage.state.costMask
    },
    // 编辑回显
    suppliersetEidt () {
      return supplierManage.state.suppliersetEidt
    },
    // 是否为配送费、退货费
    isDeliveryCancel () {
      let {costProject} = this.ruleForm
      if (costProject === 'COST_PRO_RETURN_REMAINING' || costProject === 'COST_PRO_RETURN_SALES' || costProject === 'COST_PRO_SEND' || costProject === 'COST_PRO_SEND_REPLENISH' || costProject === 'COST_PRO_RETURN_REJECT') {
        return true
      }
      return false
    },
    // 是否显示不足一箱
    isShowBox () {
      return this.computeRule(['RECKON_TYPE_BOX_DAY', 'RECKON_TYPE_BOX'])
    },
    // 是否显示计算规则
    isShowComputeRule () {
      return this.computeRule(['RECKON_TYPE_CUBIC_DAY', 'RECKON_TYPE_CUBIC_TONS'])
    }
  },
  watch: {
    // 标识监听
    costMask: {
      deep: true,
      handler (val) {
        if (val === 1) {
          supplierManage.state.costMask = 0
          this.getList()
          this.handleClose()
        }
      }
    },
    // 编辑回显数据监听
    suppliersetEidt: {
      deep: true,
      handler (val) {
        let result = JSON.parse(JSON.stringify(val))
        if (val.dispatchConfigList && val.dispatchConfigList.length > 0) {
          result.dispatchConfigList.forEach(item => {
            item.date = item.startTime ? item.startTime.trim().split(' ')[0] : '' // 开始时间
            item.time = item.startTime ? item.startTime.trim().split(' ')[1].substring(0, 5) : '' // 开始日期
          })
        }
        if (!result.startPriceConfig) result.startPriceConfig = 0
        this.ruleForm = result

        // 获取配送仓点列表
        this.getStorehouseList()
      }
    },
    storehouseList: {
      deep: true,
      handler (val) {
        if (!this.isDeliveryCancel || val.length === 0) return false

        let arrList = JSON.parse(JSON.stringify(val))
        for (let key in arrList) {
          arrList[key].computeType = ''
          arrList[key].price = ''
          arrList[key].volumePrice = ''
          arrList[key].beginVal = ''
          arrList[key].startPrice = ''
          arrList[key].volumeStartPrice = ''
          arrList[key].volumeBeginVal = ''
          arrList[key].dimension = ''
          arrList[key].date = ''
          arrList[key].smallestUnit = 0
          arrList[key].smallestRule = { a: 4, b: 4, c: 4 }
          arrList[key].isAcc = 0
        }
        let obj = this.ruleForm.dispatchConfigList.reduce((total, cur) => {
          total[cur.ydppCode] = cur
          return total
        }, {})
        this.ruleForm.dispatchConfigList = arrList.map((v) => {
          const { ydppCode } = v
          if (obj[ydppCode]) {
            return obj[ydppCode]
          }
          return v
        })
      }
    },
    'ruleForm.costProject': {
      deep: true,
      handler (val) {
        if (val) {
          if (val === 'COST_PRO_MOVE') {
            this.arr = this.chargingSelect.dockSelect
          } else if (this.isDeliveryCancel) {
            this.arr = this.chargingSelect.runSelect
          } else if (val === 'COST_PRO_COATED') {
            this.arr = this.chargingSelect.envelopeSelect
          } else if (val.indexOf('COST_PRO_LABLE') !== -1) {
            this.arr = this.chargingSelect.individualSelect
          } else {
            this.arr = this.chargingSelect.storageSelect
          }

          // 配送仓点
          if (this.isDeliveryCancel) {
            // 编辑回填
            if (this.ruleForm.dispatchConfigList.length > 0 && this.ruleForm.dispatchConfigList[0].id) return false

            // 新增
            this.ruleForm.dispatchConfigList = this.storehouseList.map(item => {
              return {ydppCode: item.ydppCode, computeType: '', price: '', volumePrice: '', beginVal: '', startPrice: '', volumeStartPrice: '', volumeBeginVal: '', dimension: '', date: '', smallestUnit: 1, smallestRule: { a: 4, b: 4, c: 4 }, isAcc: 0}
            })
          }
        }
      }
    },
    // 计费方式
    'ruleForm.computeType': {
      deep: true,
      handler (val) {
        if (!val || this.ruleForm.id) return false

        if (val === 'RECKON_TYPE_PLATE_DAY') {
          this.ruleForm.remainder = 0
        } else {
          this.ruleForm.remainder = ''
        }
      }
    },
    // 余数计算
    'ruleForm.remainder': {
      deep: true,
      handler (val) {
        if (val === 1) return false
        this.ruleForm.remainderRatio = ''
      }
    },
    // 重新请求数据
    $route (to, from) {
      if (this.$route.params) {
        this.supplierCode = this.$route.params.supplierCode
        this.supplierName = this.$route.params.supplierName
        this.warehouseCode = this.$route.params.warehouseCode
        this.getList()
      }
      if (to.name === 'costconfigure') {
        this.getList()
      }
    },
    // 新增收费项目下拉框
    suppliersetList: {
      deep: true,
      handler (val) {
        let codes = this.suppliersetList.map(item => item.costProject)
        setTimeout(() => {
          this.select = this.projectSelect.filter(item => !codes.includes(item.code))
        }, 100)
        // console.log(codes, '收费信息')
        // console.log(result, '收费信息')
      }
    }
  },
  mounted () {
    // 获取供应商code name
    this.supplierCode = this.$route.params.supplierCode
    this.supplierName = this.$route.params.supplierName
    this.warehouseCode = this.$route.params.warehouseCode
    // console.log(this.$route.params)
    // 收费类型下拉框
    this.getproject()
    // 计费维度下拉框
    this.getdimension()
    // 时长类型下拉框
    this.getduration()
    // 计算方式下拉框
    this.getcost()
    // 获取列表数据
    this.getList()
  },
  methods: {
    // 获取列表数据
    getList () {
      let params = {
        supplierCode: this.supplierCode,
        warehouseCode: this.warehouseCode
      }
      this.$store.dispatch(GETSUPPLIERCOST, params)
    },
    // 获取配送仓点列表
    getStorehouseList () {
       console.log(window.localStorage.getItem('identity'),'warehouseCodewindow.localStorage.getIt');
      if (window.localStorage.getItem('identity') === '3') {
        this.$store.dispatch(YCDISPATCHPLATFORMPOINT, {isSaaS: 1, supplierCode: this.supplierCode, warehouseCode: this.warehouseCode})
      } else {
        this.$store.dispatch(YCDISPATCHPLATFORMPOINT, {isSaaS: 0, supplierCode: this.supplierCode, warehouseCode: this.warehouseCode})
      }
    },
    // 收费类型下拉框
    getproject () {
      let params = {
        parentCode: 'COST_PRO',
        type: 'project'
      }
      this.$store.dispatch(GETCHILDS, params)
    },
    // 计费维度下拉框
    getdimension () {
      let params = {
        parentCode: 'COST_DIMENSION',
        type: 'dimension'
      }
      this.$store.dispatch(GETCHILDS, params)
    },
    // 计算方式下拉框
    getcost () {
      let params = {
        parentCode: 'RECKON_TYPE',
        type: 'computed'
      }
      this.$store.dispatch(GETCHILDS, params)
    },
    // 时长类型下拉框
    getduration () {
      let params = {
        parentCode: 'DURATION',
        type: 'duration'
      }
      this.$store.dispatch(GETCHILDS, params)
    },
    // 编辑回显数据
    geteditdata (id) {
      let params = {
        id,
        supplierCode: this.supplierCode,
        warehouseCode: this.warehouseCode
      }
      this.$store.dispatch(GETCOSTBYID, params)
    },
    // 新增
    add () {
      // 获取配送仓点列表
      this.getStorehouseList()

      this.ruleForm = { // 表单数据
        costProject: '', // 收费项目 数据字典
        dimension: '', // 计费维度 数据字典
        computeType: '', // 计算方式 数据字典
        time: '', // 开始时间
        date: '', // 开始日期
        // startTime: '', // 开始时间
        duration: '', // 时长
        durationType: '', // 时长类型
        price: '', // 单价
        startPrice: '', // 起步价
        beginVal: '', // 首重
        volumePrice: '', // 体积的单价
        volumeStartPrice: '', // 体积的起步价
        volumeBeginVal: '', // 体积的首重
        dispatchConfigList: [], // 配送仓点
        remainder: '',
        remainderRatio: '',
        smallestUnit: 0,
        smallestRule: { a: 4, b: 4, c: 4 },
        isAcc: 0,
        startPriceConfig: 0
      }
      this.dialogForm = {
        title: '新增收费项目',
        visible: true
      }
      this.arr = []
    },
    // 编辑
    edit (row) {
      this.dialogForm = {
        title: '编辑收费项目',
        visible: true
      }
      this.geteditdata(row.id)
      // console.log(row)
    },
    // 删除
    delet (row) {
      // console.log(row)
      this.$confirm('您确定要删除当前收费项目吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          id: row.id,
          supplierCode: this.supplierCode,
          warehouseCode: this.warehouseCode
        }
        this.$store.dispatch(SUPPLIERDELETE, params)
      }).catch(() => {})
    },
    // 收费项目下拉框选择
    costChange () {
      this.ruleForm.dimension = '' // 计费维度
      this.ruleForm.computeType = '' // 计算方式
      this.ruleForm.price = '' // 单价
      this.ruleForm.startPrice = '' // 起步价
      this.ruleForm.beginVal = '' // 首重
      this.ruleForm.volumePrice = '' // 体积的单价
      this.ruleForm.volumeStartPrice = '' // 体积的起步价
      this.ruleForm.volumeBeginVal = '' // 体积的首重
      this.ruleForm.date = '' // 开始日期
      this.ruleForm.time = '' // 开始时间
      this.ruleForm.duration = '' // 时长
      this.ruleForm.durationType = '' // 时长类型
      this.ruleForm.remainder = ''
      this.ruleForm.remainderRatio = ''
      this.ruleForm.smallestUnit = 0 // 不足一箱
      this.ruleForm.smallestRule = { a: 4, b: 4, c: 4 }
      this.ruleForm.isAcc = 0
    },
    // 计费方式下拉框选择
    computeChange (data) {
      data.price = '' // 单价
      data.volumePrice = '' // 体积的单价
      data.dimension = '' // 计费维度
      this.ruleForm.smallestUnit = 0 // 不足一箱
      this.ruleForm.smallestRule = { a: 4, b: 4, c: 4 }
      this.ruleForm.isAcc = 0
      if (data.computeType === 'RECKON_TYPE_CUBIC_TONS') {
        data.beginVal = 0 // 首重
        data.startPrice = 0 // 起步价
        data.volumeStartPrice = 0 // 体积的起步价
        data.volumeBeginVal = 0 // 体积的首重
        data.startPriceConfig = '0'
      } else {
        data.startPrice = '' // 起步价
        data.beginVal = '' // 首重
        data.volumeStartPrice = '' // 体积的起步价
        data.volumeBeginVal = '' // 体积的首重
      }
    },
    formatDate (date) {
      let y = date.getFullYear()
      let m = date.getMonth() + 1
      m = m < 10 ? '0' + m : m
      let d = date.getDate() + 1
      d = d < 10 ? ('0' + d) : d
      return y + '-' + m + '-' + d
    },
    // 计费维度下拉框选择
    dimensionChange (data) {
      if (data.dimension === 'COST_DIMENSION_FIXED_PERIOD') {
        data.date = this.formatDate(new Date())
        data.time = this.defaultTime
        data.duration = ''
        data.durationType = 'DURATION_HOUR'
      } else {
        data.date = ''
        data.time = ''
        data.duration = ''
        data.durationType = ''
      }
    },
    // 开始时间选择
    timeChange (e) {
      // console.log(e)
    },
    // 提交
    submit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.checkForm()) return false

          let data = this.ruleForm
          let flag = true
          if (this.isDeliveryCancel && data.dispatchConfigList.length > 0) {
            data.dispatchConfigList.forEach(item => {
              if (item.computeType === 'RECKON_TYPE_CUBIC_TONS' && item.dimension === 'COST_DIMENSION_FIXED_PERIOD') {
                item.startTime = (item.date + ' ' + item.time).length < 19 ? item.date + ' ' + item.time + ':00' : item.date + ' ' + item.time // 开始时间
                item.duration = item.duration // 时长
                item.durationType = item.durationType // 时长类型

                if (!this.judgeTime(item.startTime)) {
                  this.$message({
                    showClose: true,
                    message: '选择日期时间需大于当前日期时间',
                    type: 'error'
                  })
                  flag = false
                }
              }
            })
          }
          if (!flag) return

          let params = {
            supplierCode: this.supplierCode, // 供应商code
            costProject: data.costProject, // 收费项目 数据字典
            dimension: data.dimension, // 计费维度 数据字典
            computeType: data.computeType, // 计算方式 数据字典
            price: data.price, // 单价
            startPrice: data.startPrice, // 起步价
            beginVal: data.beginVal, // 首重
            volumePrice: data.volumePrice, // 体积的单价
            volumeStartPrice: data.volumeStartPrice, // 体积的起步价
            volumeBeginVal: data.volumeBeginVal, // 体积的首重
            remainder: data.remainder, // 余数计算
            remainderRatio: data.remainderRatio, // 比值
            dispatchConfigList: this.isDeliveryCancel && data.dispatchConfigList.length > 0 ? data.dispatchConfigList : null, // 退货费、配送费 仓点List
            smallestUnit: data.smallestUnit,
            smallestRule: JSON.stringify(data.smallestRule),
            isAcc: data.isAcc,
            startPriceConfig: data.startPriceConfig,
            warehouseCode: this.warehouseCode
          }
          console.log(params.warehouseCode)
          if (this.dialogForm.title === '新增收费项目') {
            this.$store.dispatch(SUPPLIERADDCOST, params)
          } else if (this.dialogForm.title === '编辑收费项目') {
            params.id = data.id
            this.$store.dispatch(SUPPLIERUPDATECOST, params)
          }
          // console.log(params, 'submit!')
        } else {
          // console.log('error submit!!')
          return false
        }
      })
    },
    // 验证表单
    checkForm () {
      let flag = true
      if (this.isDeliveryCancel) {
        let configList = this.ruleForm.dispatchConfigList
        if (configList.length === 0 || this.storehouseList.length === 0) {
          flag = false
          return this.$message.error('请先配置配送仓点')
        }
        let length = 0
        for (let i = 0; i < configList.length; i++) {
          let item = configList[i]
          if (item.computeType || item.price) {
            if (item.computeType === '' || item.price === '') {
              flag = false
              this.$message.error('请输入完整的信息')
              break
            }
            let reg = /(^\d+$)|(^\d+\.\d+$)/
            if (!reg.test(item.price)) {
              flag = false
              this.$message.error('请输入大于0的数字')
              break
            }
            // 退货费、配送费
            if (item.computeType === 'RECKON_TYPE_CUBIC_TONS') {
              // 计费维度
              if (!item.dimension) {
                flag = false
                this.$message.error('请输入计费维度')
                break
              }
              if (!reg.test(item.beginVal) || !reg.test(item.startPrice) || !reg.test(item.price) || !reg.test(item.volumeBeginVal) || !reg.test(item.volumeStartPrice) || !reg.test(item.volumePrice)) {
                flag = false
                this.$message.error('请输入大于0的数字')
                break
              }
              // 计费维度 - 固定周期
              if (item.dimension === 'COST_DIMENSION_FIXED_PERIOD') {
                if (!item.date || !item.time || !item.duration || !item.durationType) {
                  flag = false
                  this.$message.error('请输入完整的信息')
                  break
                }
              }
            }
          } else {
            length += 1
          }
        }
        if (length === configList.length) {
          flag = false
          this.$message.error('至少配置一个仓点')
        }
      }
      return flag
    },
    // 时间选择判断 -- 提交
    judgeTime (time) {
      // var strtime = time.replace('/-/g', '/')// 时间转换
      // 时间
      var date1 = new Date(time)
      // 现在时间
      var date2 = new Date()
      // 判断时间是否过期
      // console.log(time, date1, date2)
      return !(date1 < date2)
    },
    // 关闭弹窗
    handleClose () {
      if (this.$refs['ruleForm']) {
        this.$refs['ruleForm'].resetFields()
        this.$refs['ruleForm'].clearValidate()
      }
      this.dialogForm.visible = false
      this.activeName = '0' // tabs切换
    },
    // 搜索
    search () {
      this.getList()
    },
    // 单价正整数校验
    validateNum (rule, value, callback) {
      if (value !== '') {
        if (this.isDeliveryCancel && this.ruleForm.computeType === 'RECKON_TYPE_CUBIC_TONS') {
          if (!isNaN(value) || Number(value) > 0) {
            callback()
          } else {
            callback(new Error('续重单价需大于0'))
          }
        } else {
          if (!isNaN(value) || Number(value) >= 0) {
            callback()
          } else {
            callback(new Error('请输入正确的正整数'))
          }
        }
      } else {
        if (this.ruleForm.costProject !== 'COST_PRO_MOVE' && this.ruleForm.costProject !== 'COST_PRO_SEND') {
          callback(new Error('请输入单价'))
        } else if (this.ruleForm.costProject === 'COST_PRO_MOVE' && this.ruleForm.computeType === 'RECKON_TYPE_CUBIC_TONS') {
          callback(new Error('请输入每吨单价'))
        } else if (this.ruleForm.costProject === 'COST_PRO_SEND' && this.ruleForm.computeType === 'RECKON_TYPE_CUBIC_TONS') {
          callback(new Error('请输入续重单价'))
        } else {
          callback(new Error('请输入单价'))
        }
      }
    },
    // 首重/起步价/续费单价校验
    validateVal (rule, value, callback) {
      if (value !== '' && Number(value) >= 0) {
        callback()
      } else {
        callback(new Error('请输入≥0的数字'))
      }
    },
    // 时长正值数校验
    validateTime (rule, value, callback) {
      if (value !== '') {
        if ((value > 0 || Number(value) > 0) && (value.toString().indexOf('.') === -1 || value.indexOf('.') === -1)) {
          callback()
        } else {
          callback(new Error('请输入大于0的正整数'))
        }
      } else {
        callback(new Error('请输入时长'))
      }
    },
    // 体积单价正整数校验
    validateVolume (rule, value, callback) {
      if (value !== '') {
        if (this.ruleForm.costProject === 'COST_PRO_SEND' && this.ruleForm.computeType === 'RECKON_TYPE_CUBIC_TONS') {
          if (Number(value) >= 0) {
            callback()
          } else {
            callback(new Error('续重单价不可小于0'))
          }
        } else {
          if (Number(value) >= 0) {
            callback()
          } else {
            callback(new Error('请输入正确的正整数'))
          }
        }
      } else {
        if (this.ruleForm.costProject === 'COST_PRO_SEND') {
          callback(new Error('请输入续重单价'))
        } else {
          callback(new Error('请输入每立方单价'))
        }
      }
    },
    validateNumber (rule, value, callback) {
      let reg = /^[0-9]+\.?[0-9]*$/
      if (value === '' || !reg.test(value) || Number(value) > 99 || Number(value) < 1 || (value.toString()).indexOf('.') > -1) {
        return callback(new Error('请输入正值整数1-99'))
      }
      callback()
    },
    // 数值转化
    Num (data) {
      // console.log(data, '数值转化')
      let vv = Math.pow(10, 2)
      if (!isNaN(data.price) && data.price) {
        data.price = Math.round(data.price * vv) / vv
        // data.price = parseFloat(parseFloat(data.price).toFixed(2))
      }
      if (data.startPrice) {
        data.startPrice = Math.round(data.startPrice * vv) / vv
      }
      if (data.beginVal) {
        data.beginVal = Math.floor(data.beginVal)
      }
      if (data.volumePrice) {
        data.volumePrice = Math.round(data.volumePrice * vv) / vv
      }
      if (data.volumeStartPrice) {
        data.volumeStartPrice = Math.round(data.volumeStartPrice * vv) / vv
      }
      if (data.volumeBeginVal) {
        data.volumeBeginVal = Math.floor(data.volumeBeginVal)
      }
      if (data.duration) {
        data.duration = Math.floor(data.duration)
      }
    },
    // 是否显示计算规则
    computeRule (arr) {
      let flag = [false]
      if (arr.indexOf(this.ruleForm.computeType) > -1) {
        flag = [true]
      }
      if (this.isDeliveryCancel) {
        flag = []
        this.ruleForm.dispatchConfigList.forEach(item => {
          if (arr.indexOf(item.computeType) > -1) {
            return flag.push(true)
          }
          flag.push(false)
        })
      }
      return flag
    }
  }
}
</script>

<style scoped>
  .desc {
    color: #808080;
    margin-left: 125px;
    display: block;
    margin-bottom: 22px;
    line-height: 1.3rem;
    margin-right: 16%;
    letter-spacing: 1px;
  }
  .date-select {
    display: flex;
    width: 80%;
  }
  .operation-warp {
    display: flex;
    align-items: center;
    justify-content: space-around;
    color: #409EFF;
  }
  .operation-warp div:hover {
    color: #66b1ff;
  }
  .input-with-select >>> .el-input-group__append {
    background-color: #fff !important;
    padding: 0px !important;
    width: 100px !important;
  }
  .el-input-group__append .el-select {
    width: 100% !important;
    margin: -10px 0px !important;
  }
  .input-with-select .el-input-group__append .el-select >>> .el-input__inner {
    text-align: center !important;
  }
  .input-with-select >>> .el-form-item__content {
    line-height: 34px !important;
  }
  .tips {
    position: absolute;
    top: 200px;
    left: 50%;
    transform: translateX(-50%);
  }
</style>



// WEBPACK FOOTER //
// src/page/supplierManage/SupplierSet.vue